import React from "react";

export default function SettingsHeroStat({ label, value }) {
  return (
    <div className="rounded-2xl border border-blue-100 bg-white/90 px-4 py-3">
      <p className="font-inter text-[11px] uppercase tracking-wider text-gray-400">
        {label}
      </p>
      <p className="mt-1 font-inter text-sm font-semibold text-gray-900">{value}</p>
    </div>
  );
}
